import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewIndustryList = () => { 
    return useQuery({ 
        queryKey: ['viewindustry'], 
        queryFn: async () => { 
            const res = await api.get('/industries/list', {
            }); 
            return res.data; 
        }
     });
};  